export default __webpack_public_path__ + "static/media/search-icon.078d3a25.svg";